import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { withoutSystem, withSystem } from '../data/content';
export function CostOfInaction() {
  return <section aria-labelledby="costo" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-53" data-mp="2uxawcr9tgqoa">
      <Reveal data-id="element-54" data-mp="2zxyndcy1p7ii">
        <h2 id="costo" className="mx-auto max-w-3xl font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-55" data-mp="2zyi2yn083jtd">
          ¿Cuánto te cuesta seguir dejándote para después?
        </h2>
      </Reveal>

      <div className="mx-auto mt-6 grid max-w-5xl gap-3 md:grid-cols-2" data-id="element-56" data-mp="3dobs76fn463m">
        <Reveal className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface-alt p-6" data-id="element-57" data-mp="3dp3n0f1exzsu">
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-ink-subtle" data-id="element-58" data-mp="3ip98tel04s30">
            Sin Mega Pack
          </h3>
          <ul className="mt-4 w-full space-y-2" data-id="element-59" data-mp="3sl2txmcsdtwe">
            {withoutSystem.map(item => <li key={item} className="flex items-center justify-center gap-2 text-sm text-ink-muted" data-id="element-60" data-mp="3eg6m2qe1vvr1">
                <XIcon size={14} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-61" data-mp="39g20wn276cuh" />
                <span data-id="element-62" data-mp="30hgn157o7m01">{item}</span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.05} className="flex h-full flex-col items-center rounded-2xl border border-accent/25 bg-accent-soft p-6" data-id="element-63" data-mp="11tfbyy3embt">
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-64" data-mp="3sa79wp3grycm">
            Con Mega Pack Vuelve a Ti™
          </h3>
          <ul className="mt-4 w-full space-y-2" data-id="element-65" data-mp="3jgcg2d7sluca">
            {withSystem.map(item => <li key={item} className="flex items-center justify-center gap-2 text-sm font-semibold text-ink" data-id="element-66" data-mp="jskyttbsnt3x">
                <CheckIcon size={14} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-67" data-mp="ez89ti37dkan" />
                <span data-id="element-68" data-mp="2e6yg8gp0sxna">{item}</span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}